"use strict";

exports.imageClass = "gatsby-resp-image-image";
exports.imageWrapperClass = "gatsby-resp-image-wrapper";
exports.imageBackgroundClass = "gatsby-resp-image-background-image";


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-remark-images/constants.js
// module id = 371
// module chunks = 231608221292675